import request from "@/utils/request.js";
const baseurl = '/publicity'
const uploadUrl = '/file'
const api = {
    publicList: (data) => {
        return request({
            url: baseurl + "/api/wxzjgsxx/gzh/list",
            method: "post",
            data,
        });
    },
    // 公示详情
    getDetail: (id) => {
        return request({
            url: baseurl + `/api/wxzjgsxx/gzh/get/${id}`,
            method: "get",
        });
    },

    // 下载文件
    minioDownload: (params) => {
        return request({
            method: "post",
            responseType: 'blob',
            url: uploadUrl + "/minioDownload",
            "Content-type": "multipart/form-data",
            params,
        });
    },
    // 上传文件

    uploadfile: (data) => {
        return request({
            method: "post",
            url: uploadUrl + "/minioUpload",
            "Content-type": "multipart/form-data",
            data,
        });
    },
}
export default api;